import { render, staticRenderFns } from "./messageCenterDialog.vue?vue&type=template&id=5c0b86fc&scoped=true"
import script from "./messageCenterDialog.vue?vue&type=script&lang=js"
export * from "./messageCenterDialog.vue?vue&type=script&lang=js"
import style0 from "./messageCenterDialog.vue?vue&type=style&index=0&id=5c0b86fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0b86fc",
  null
  
)

export default component.exports